(function () {
function $554ed4b40b13e16f$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $554ed4b40b13e16f$export$71511d61b312f219(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $554ed4b40b13e16f$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $554ed4b40b13e16f$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ function $0b5c99e6a0876eaa$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}


var $fc5e3658b603cf39$var$extendStatics = function extendStatics1(d, b) {
    $fc5e3658b603cf39$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $fc5e3658b603cf39$var$extendStatics(d, b);
};
function $fc5e3658b603cf39$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $fc5e3658b603cf39$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $fc5e3658b603cf39$export$18ce0697a983be9b = function __assign1() {
    $fc5e3658b603cf39$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $fc5e3658b603cf39$export$18ce0697a983be9b.apply(this, arguments);
};
function $fc5e3658b603cf39$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $fc5e3658b603cf39$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $fc5e3658b603cf39$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $fc5e3658b603cf39$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $fc5e3658b603cf39$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $fc5e3658b603cf39$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $0b5c99e6a0876eaa$export$71511d61b312f219)(x)) === "symbol" ? x : "".concat(x);
}
function $fc5e3658b603cf39$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $0b5c99e6a0876eaa$export$71511d61b312f219)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $fc5e3658b603cf39$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $fc5e3658b603cf39$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $fc5e3658b603cf39$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $fc5e3658b603cf39$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $fc5e3658b603cf39$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $fc5e3658b603cf39$export$45d3717a4c69092e(o, m, p);
}
function $fc5e3658b603cf39$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $fc5e3658b603cf39$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $fc5e3658b603cf39$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($fc5e3658b603cf39$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $fc5e3658b603cf39$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $fc5e3658b603cf39$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $fc5e3658b603cf39$export$10c90e4f7922046c(v) {
    return this instanceof $fc5e3658b603cf39$export$10c90e4f7922046c ? (this.v = v, this) : new $fc5e3658b603cf39$export$10c90e4f7922046c(v);
}
function $fc5e3658b603cf39$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $fc5e3658b603cf39$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $fc5e3658b603cf39$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $fc5e3658b603cf39$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $fc5e3658b603cf39$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $fc5e3658b603cf39$export$19a8beecd37a4c45 === "function" ? $fc5e3658b603cf39$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $fc5e3658b603cf39$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $fc5e3658b603cf39$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $fc5e3658b603cf39$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $fc5e3658b603cf39$export$45d3717a4c69092e(result, mod, k);
    }
    $fc5e3658b603cf39$var$__setModuleDefault(result, mod);
    return result;
}
function $fc5e3658b603cf39$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $fc5e3658b603cf39$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $fc5e3658b603cf39$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $fc5e3658b603cf39$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $fc5e3658b603cf39$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $fc5e3658b603cf39$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $fc5e3658b603cf39$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $fc5e3658b603cf39$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $fc5e3658b603cf39$export$2e2bcd8739ae039 = {
    __extends: $fc5e3658b603cf39$export$a8ba968b8961cb8a,
    __assign: $fc5e3658b603cf39$export$18ce0697a983be9b,
    __rest: $fc5e3658b603cf39$export$3c9a16f847548506,
    __decorate: $fc5e3658b603cf39$export$29e00dfd3077644b,
    __param: $fc5e3658b603cf39$export$d5ad3fd78186038f,
    __metadata: $fc5e3658b603cf39$export$f1db080c865becb9,
    __awaiter: $fc5e3658b603cf39$export$1050f835b63b671e,
    __generator: $fc5e3658b603cf39$export$67ebef60e6f28a6,
    __createBinding: $fc5e3658b603cf39$export$45d3717a4c69092e,
    __exportStar: $fc5e3658b603cf39$export$f33643c0debef087,
    __values: $fc5e3658b603cf39$export$19a8beecd37a4c45,
    __read: $fc5e3658b603cf39$export$8d051b38c9118094,
    __spread: $fc5e3658b603cf39$export$afc72e2116322959,
    __spreadArrays: $fc5e3658b603cf39$export$6388937ca91ccae8,
    __spreadArray: $fc5e3658b603cf39$export$1216008129fb82ed,
    __await: $fc5e3658b603cf39$export$10c90e4f7922046c,
    __asyncGenerator: $fc5e3658b603cf39$export$e427f37a30a4de9b,
    __asyncDelegator: $fc5e3658b603cf39$export$bbd80228419bb833,
    __asyncValues: $fc5e3658b603cf39$export$e3b29a3d6162315f,
    __makeTemplateObject: $fc5e3658b603cf39$export$4fb47efe1390b86f,
    __importStar: $fc5e3658b603cf39$export$c21735bcef00d192,
    __importDefault: $fc5e3658b603cf39$export$da59b14a69baef04,
    __classPrivateFieldGet: $fc5e3658b603cf39$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $fc5e3658b603cf39$export$d40a35129aaff81f,
    __classPrivateFieldIn: $fc5e3658b603cf39$export$81fdc39f203e4e04,
    __addDisposableResource: $fc5e3658b603cf39$export$88ac25d8e944e405,
    __disposeResources: $fc5e3658b603cf39$export$8f076105dc360e92
};



function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $ac3905202f0710b7$export$71511d61b312f219(receiver, descriptor) {
    if (descriptor.get) return descriptor.get.call(receiver);
    return descriptor.value;
}


function $753de3cb5925592a$export$71511d61b312f219(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to " + action + " private field on non-instance");
    return privateMap.get(receiver);
}


function $2f97c2a4ea6269f4$export$71511d61b312f219(receiver, privateMap) {
    var descriptor = (0, $753de3cb5925592a$export$71511d61b312f219)(receiver, privateMap, "get");
    return (0, $ac3905202f0710b7$export$71511d61b312f219)(receiver, descriptor);
}


function $f86983e96b0c893e$export$71511d61b312f219(obj, privateCollection) {
    if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}


function $5d6c3530fa14a187$export$71511d61b312f219(obj, privateMap, value) {
    (0, $f86983e96b0c893e$export$71511d61b312f219)(obj, privateMap);
    privateMap.set(obj, value);
}


function $a91e4d47d6e0e68a$export$71511d61b312f219(receiver, descriptor, value) {
    if (descriptor.set) descriptor.set.call(receiver, value);
    else {
        if (!descriptor.writable) // This should only throw in strict mode, but class bodies are
        // always strict and private fields can only be used inside
        // class bodies.
        throw new TypeError("attempted to set read only private field");
        descriptor.value = value;
    }
}



function $20d5c04b0c6865c9$export$71511d61b312f219(receiver, privateMap, value) {
    var descriptor = (0, $753de3cb5925592a$export$71511d61b312f219)(receiver, privateMap, "set");
    (0, $a91e4d47d6e0e68a$export$71511d61b312f219)(receiver, descriptor, value);
    return value;
}


function $ac6739cbe5bf1c84$export$71511d61b312f219(receiver, privateSet, fn) {
    if (!privateSet.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return fn;
}



function $ea91727f98d0802f$export$71511d61b312f219(obj, privateSet) {
    (0, $f86983e96b0c893e$export$71511d61b312f219)(obj, privateSet);
    privateSet.add(obj);
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $cd5a47cf8ef6d766$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $09cbfe85151ea6c6$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}


function $8ca2848f896a6803$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}


function $a0bc1859061deae1$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
}


function $efec029548ccee7f$export$71511d61b312f219(arr, i) {
    return (0, $09cbfe85151ea6c6$export$71511d61b312f219)(arr) || (0, $8ca2848f896a6803$export$71511d61b312f219)(arr, i) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr, i) || (0, $a0bc1859061deae1$export$71511d61b312f219)();
}



function $c50969dc1df61e8b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(arr);
}


function $09c9f293d010c0e1$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $38c2d4931cb7a7c4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $227c6742e0ff6f82$export$71511d61b312f219(arr) {
    return (0, $c50969dc1df61e8b$export$71511d61b312f219)(arr) || (0, $09c9f293d010c0e1$export$71511d61b312f219)(arr) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr) || (0, $38c2d4931cb7a7c4$export$71511d61b312f219)();
}















var $19d9ff0b7faaf8c5$var$_cellElement = /*#__PURE__*/ new WeakMap(), $19d9ff0b7faaf8c5$var$_x = /*#__PURE__*/ new WeakMap(), $19d9ff0b7faaf8c5$var$_y = /*#__PURE__*/ new WeakMap(), $19d9ff0b7faaf8c5$var$_tile = /*#__PURE__*/ new WeakMap(), $19d9ff0b7faaf8c5$var$_mergeTile = /*#__PURE__*/ new WeakMap();
var $19d9ff0b7faaf8c5$export$f6f0c3fe4ec306ea = /*#__PURE__*/ function() {
    "use strict";
    function Cell(cellElement, x, y) {
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Cell);
        (0, $5d6c3530fa14a187$export$71511d61b312f219)(this, $19d9ff0b7faaf8c5$var$_cellElement, {
            writable: true,
            value: void 0
        });
        (0, $5d6c3530fa14a187$export$71511d61b312f219)(this, $19d9ff0b7faaf8c5$var$_x, {
            writable: true,
            value: void 0
        });
        (0, $5d6c3530fa14a187$export$71511d61b312f219)(this, $19d9ff0b7faaf8c5$var$_y, {
            writable: true,
            value: void 0
        });
        (0, $5d6c3530fa14a187$export$71511d61b312f219)(this, $19d9ff0b7faaf8c5$var$_tile, {
            writable: true,
            value: void 0
        });
        (0, $5d6c3530fa14a187$export$71511d61b312f219)(this, $19d9ff0b7faaf8c5$var$_mergeTile, {
            writable: true,
            value: void 0
        });
        (0, $20d5c04b0c6865c9$export$71511d61b312f219)(this, $19d9ff0b7faaf8c5$var$_cellElement, cellElement);
        (0, $20d5c04b0c6865c9$export$71511d61b312f219)(this, $19d9ff0b7faaf8c5$var$_x, x);
        (0, $20d5c04b0c6865c9$export$71511d61b312f219)(this, $19d9ff0b7faaf8c5$var$_y, y);
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Cell, [
        {
            key: "x",
            get: function get() {
                return (0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $19d9ff0b7faaf8c5$var$_x);
            }
        },
        {
            key: "y",
            get: function get() {
                return (0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $19d9ff0b7faaf8c5$var$_y);
            }
        },
        {
            key: "tile",
            get: function get() {
                return (0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $19d9ff0b7faaf8c5$var$_tile);
            },
            set: function set(value) {
                (0, $20d5c04b0c6865c9$export$71511d61b312f219)(this, $19d9ff0b7faaf8c5$var$_tile, value);
                if (value == null) return;
                (0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $19d9ff0b7faaf8c5$var$_tile).x = (0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $19d9ff0b7faaf8c5$var$_x);
                (0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $19d9ff0b7faaf8c5$var$_tile).y = (0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $19d9ff0b7faaf8c5$var$_y);
            }
        },
        {
            key: "mergeTile",
            get: function get() {
                return (0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $19d9ff0b7faaf8c5$var$_mergeTile);
            },
            set: function set(value) {
                (0, $20d5c04b0c6865c9$export$71511d61b312f219)(this, $19d9ff0b7faaf8c5$var$_mergeTile, value);
                if (value == null) return;
                (0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $19d9ff0b7faaf8c5$var$_mergeTile).x = (0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $19d9ff0b7faaf8c5$var$_x);
                (0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $19d9ff0b7faaf8c5$var$_mergeTile).y = (0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $19d9ff0b7faaf8c5$var$_y);
            }
        },
        {
            key: "canAccept",
            value: function canAccept(tile) {
                return this.tile == null || this.mergeTile == null && this.tile.value === tile.value;
            }
        },
        {
            key: "mergeTiles",
            value: function mergeTiles() {
                if (this.tile == null || this.mergeTile == null) return;
                this.tile.value = this.tile.value + this.mergeTile.value;
                this.mergeTile.remove();
                this.mergeTile = null;
                return this.tile.value;
            }
        }
    ]);
    return Cell;
}();








var $36a3b75bc163819c$var$_tileElement = /*#__PURE__*/ new WeakMap(), $36a3b75bc163819c$var$_x = /*#__PURE__*/ new WeakMap(), $36a3b75bc163819c$var$_y = /*#__PURE__*/ new WeakMap(), $36a3b75bc163819c$var$_value = /*#__PURE__*/ new WeakMap();
var $36a3b75bc163819c$export$235cb65c20ad2b7 = /*#__PURE__*/ function() {
    "use strict";
    function Tile(tileContainer) {
        var value = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Math.random() > 0.1 ? 2 : 4;
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Tile);
        (0, $5d6c3530fa14a187$export$71511d61b312f219)(this, $36a3b75bc163819c$var$_tileElement, {
            writable: true,
            value: void 0
        });
        (0, $5d6c3530fa14a187$export$71511d61b312f219)(this, $36a3b75bc163819c$var$_x, {
            writable: true,
            value: void 0
        });
        (0, $5d6c3530fa14a187$export$71511d61b312f219)(this, $36a3b75bc163819c$var$_y, {
            writable: true,
            value: void 0
        });
        (0, $5d6c3530fa14a187$export$71511d61b312f219)(this, $36a3b75bc163819c$var$_value, {
            writable: true,
            value: void 0
        });
        (0, $20d5c04b0c6865c9$export$71511d61b312f219)(this, $36a3b75bc163819c$var$_tileElement, document.createElement("div"));
        (0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $36a3b75bc163819c$var$_tileElement).classList.add("game__tile");
        tileContainer.append((0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $36a3b75bc163819c$var$_tileElement));
        this.value = value;
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Tile, [
        {
            key: "value",
            get: function get() {
                return (0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $36a3b75bc163819c$var$_value);
            },
            set: function set(v) {
                (0, $20d5c04b0c6865c9$export$71511d61b312f219)(this, $36a3b75bc163819c$var$_value, v);
                (0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $36a3b75bc163819c$var$_tileElement).textContent = v;
                (0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $36a3b75bc163819c$var$_tileElement).className = "game__tile game__tile--".concat(v);
            }
        },
        {
            key: "x",
            get: function get() {
                return (0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $36a3b75bc163819c$var$_x);
            },
            set: function set(value) {
                (0, $20d5c04b0c6865c9$export$71511d61b312f219)(this, $36a3b75bc163819c$var$_x, value);
                (0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $36a3b75bc163819c$var$_tileElement).style.setProperty("--x", value);
            }
        },
        {
            key: "y",
            get: function get() {
                return (0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $36a3b75bc163819c$var$_y);
            },
            set: function set(value) {
                (0, $20d5c04b0c6865c9$export$71511d61b312f219)(this, $36a3b75bc163819c$var$_y, value);
                (0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $36a3b75bc163819c$var$_tileElement).style.setProperty("--y", value);
            }
        },
        {
            key: "remove",
            value: function remove() {
                (0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $36a3b75bc163819c$var$_tileElement).remove();
            }
        },
        {
            key: "waitForTransition",
            value: function waitForTransition() {
                var _this = this;
                var animation = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                return new Promise(function(resolve) {
                    (0, $2f97c2a4ea6269f4$export$71511d61b312f219)(_this, $36a3b75bc163819c$var$_tileElement).addEventListener(animation ? "animationend" : "transitionend", resolve, {
                        once: true
                    });
                });
            }
        }
    ]);
    return Tile;
}();


var $eb8602934a216904$var$_cells = /*#__PURE__*/ new WeakMap(), $eb8602934a216904$var$_gridElement = /*#__PURE__*/ new WeakMap(), $eb8602934a216904$var$_emptyCells = /*#__PURE__*/ new WeakMap(), $eb8602934a216904$var$_createCellElements = /*#__PURE__*/ new WeakSet(), $eb8602934a216904$var$_populateInitialState = /*#__PURE__*/ new WeakSet();
var $eb8602934a216904$export$ef2184bd89960b14 = /*#__PURE__*/ function() {
    "use strict";
    function Grid(gridElement) {
        var initialGridState = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Grid);
        (0, $5d6c3530fa14a187$export$71511d61b312f219)(this, $eb8602934a216904$var$_emptyCells, {
            get: $eb8602934a216904$var$get_emptyCells,
            set: void 0
        });
        (0, $ea91727f98d0802f$export$71511d61b312f219)(this, $eb8602934a216904$var$_createCellElements);
        (0, $ea91727f98d0802f$export$71511d61b312f219)(this, $eb8602934a216904$var$_populateInitialState);
        (0, $5d6c3530fa14a187$export$71511d61b312f219)(this, $eb8602934a216904$var$_cells, {
            writable: true,
            value: void 0
        });
        (0, $5d6c3530fa14a187$export$71511d61b312f219)(this, $eb8602934a216904$var$_gridElement, {
            writable: true,
            value: void 0
        });
        (0, $20d5c04b0c6865c9$export$71511d61b312f219)(this, $eb8602934a216904$var$_gridElement, gridElement);
        gridElement.style.setProperty("--grid-size", (0, $de28aad8650ac562$export$bc90872e265d166e));
        (0, $20d5c04b0c6865c9$export$71511d61b312f219)(this, $eb8602934a216904$var$_cells, (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $eb8602934a216904$var$_createCellElements, $eb8602934a216904$var$createCellElements).call(this, gridElement).map(function(cellElement, index) {
            return new (0, $19d9ff0b7faaf8c5$export$f6f0c3fe4ec306ea)(cellElement, index % (0, $de28aad8650ac562$export$bc90872e265d166e), Math.floor(index / (0, $de28aad8650ac562$export$bc90872e265d166e)));
        }));
        if (initialGridState) (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $eb8602934a216904$var$_populateInitialState, $eb8602934a216904$var$populateInitialState).call(this, initialGridState);
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Grid, [
        {
            key: "gridElement",
            get: function get() {
                return (0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $eb8602934a216904$var$_gridElement);
            }
        },
        {
            key: "cells",
            get: function get() {
                return (0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $eb8602934a216904$var$_cells);
            }
        },
        {
            key: "cellsByRow",
            get: function get() {
                return (0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $eb8602934a216904$var$_cells).reduce(function(cellGrid, cell) {
                    cellGrid[cell.y] = cellGrid[cell.y] || [];
                    cellGrid[cell.y][cell.x] = cell;
                    return cellGrid;
                }, []);
            }
        },
        {
            key: "cellsByColumn",
            get: function get() {
                return (0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $eb8602934a216904$var$_cells).reduce(function(cellGrid, cell) {
                    cellGrid[cell.x] = cellGrid[cell.x] || [];
                    cellGrid[cell.x][cell.y] = cell;
                    return cellGrid;
                }, []);
            }
        },
        {
            key: "randomEmptyCell",
            value: function randomEmptyCell() {
                var randomIndex = Math.floor(Math.random() * (0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $eb8602934a216904$var$_emptyCells).length);
                return (0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $eb8602934a216904$var$_emptyCells)[randomIndex];
            }
        },
        {
            key: "spawnTile",
            value: function spawnTile() {
                var cell = this.randomEmptyCell();
                if (!cell) return;
                var tile = new (0, $36a3b75bc163819c$export$235cb65c20ad2b7)(this.gridElement);
                cell.tile = tile;
                return tile;
            }
        },
        {
            key: "clear",
            value: function clear() {
                (0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $eb8602934a216904$var$_cells).forEach(function(cell) {
                    if (cell.tile) {
                        cell.tile.remove();
                        cell.tile = null;
                    }
                    if (cell.mergeTile) {
                        cell.mergeTile.remove();
                        cell.mergeTile = null;
                    }
                });
            }
        }
    ]);
    return Grid;
}();
function $eb8602934a216904$var$get_emptyCells() {
    return (0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $eb8602934a216904$var$_cells).filter(function(cell) {
        return cell.tile == null;
    });
}
function $eb8602934a216904$var$createCellElements(gridElement) {
    var cells = [];
    for(var i = 0; i < (0, $de28aad8650ac562$export$bc90872e265d166e) * (0, $de28aad8650ac562$export$bc90872e265d166e); i++){
        var cell = document.createElement("div");
        cell.classList.add("game__cell");
        cells.push(cell);
        gridElement.append(cell);
    }
    return cells;
}
function $eb8602934a216904$var$populateInitialState(initialState) {
    var _this = this, _loop = function(y) {
        var _this1 = _this, _loop = function(x) {
            var value = initialState[y][x];
            if (value) {
                var cell = (0, $2f97c2a4ea6269f4$export$71511d61b312f219)(_this1, $eb8602934a216904$var$_cells).find(function(c) {
                    return c.x === x && c.y === y;
                });
                var tile = new (0, $36a3b75bc163819c$export$235cb65c20ad2b7)((0, $2f97c2a4ea6269f4$export$71511d61b312f219)(_this1, $eb8602934a216904$var$_gridElement), value);
                cell.tile = tile;
            }
        };
        for(var x = 0; x < initialState[y].length; x++)_loop(x);
    };
    for(var y = 0; y < initialState.length; y++)_loop(y);
}


var $de28aad8650ac562$export$bc90872e265d166e = 4;
var $de28aad8650ac562$var$_grid = /*#__PURE__*/ new WeakMap(), $de28aad8650ac562$var$_status = /*#__PURE__*/ new WeakMap(), $de28aad8650ac562$var$_score = /*#__PURE__*/ new WeakMap(), $de28aad8650ac562$var$_canMove = /*#__PURE__*/ new WeakSet(), $de28aad8650ac562$var$_slideTiles = /*#__PURE__*/ new WeakSet();
var $de28aad8650ac562$export$985739bfa5723e08 = /*#__PURE__*/ function() {
    "use strict";
    function Game(gridElement) {
        var initialGridState = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        (0, $ea91727f98d0802f$export$71511d61b312f219)(this, $de28aad8650ac562$var$_canMove);
        (0, $ea91727f98d0802f$export$71511d61b312f219)(this, $de28aad8650ac562$var$_slideTiles);
        (0, $5d6c3530fa14a187$export$71511d61b312f219)(this, $de28aad8650ac562$var$_grid, {
            writable: true,
            value: void 0
        });
        (0, $5d6c3530fa14a187$export$71511d61b312f219)(this, $de28aad8650ac562$var$_status, {
            writable: true,
            value: void 0
        });
        (0, $5d6c3530fa14a187$export$71511d61b312f219)(this, $de28aad8650ac562$var$_score, {
            writable: true,
            value: void 0
        });
        (0, $20d5c04b0c6865c9$export$71511d61b312f219)(this, $de28aad8650ac562$var$_grid, new (0, $eb8602934a216904$export$ef2184bd89960b14)(gridElement, initialGridState));
        (0, $20d5c04b0c6865c9$export$71511d61b312f219)(this, $de28aad8650ac562$var$_status, Game.GAME_STATUS.idle);
        (0, $20d5c04b0c6865c9$export$71511d61b312f219)(this, $de28aad8650ac562$var$_score, 0);
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            key: "grid",
            get: function get() {
                return (0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $de28aad8650ac562$var$_grid);
            }
        },
        {
            key: "score",
            get: function get() {
                return (0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $de28aad8650ac562$var$_score);
            }
        },
        {
            key: "status",
            get: function get() {
                return (0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $de28aad8650ac562$var$_status);
            }
        },
        {
            key: "isGameOver",
            get: function get() {
                return (0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $de28aad8650ac562$var$_status) === Game.GAME_STATUS.lose;
            }
        },
        {
            key: "isWin",
            get: function get() {
                return (0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $de28aad8650ac562$var$_status) === Game.GAME_STATUS.win;
            }
        },
        {
            key: "start",
            value: function start() {
                (0, $20d5c04b0c6865c9$export$71511d61b312f219)(this, $de28aad8650ac562$var$_status, Game.GAME_STATUS.playing);
                this.spawnTiles(2);
            }
        },
        {
            key: "restart",
            value: function restart() {
                (0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $de28aad8650ac562$var$_grid).clear();
                (0, $20d5c04b0c6865c9$export$71511d61b312f219)(this, $de28aad8650ac562$var$_status, Game.GAME_STATUS.idle);
                (0, $20d5c04b0c6865c9$export$71511d61b312f219)(this, $de28aad8650ac562$var$_score, 0);
            }
        },
        {
            key: "tryMove",
            value: function tryMove(direction) {
                var _this = this;
                return (0, $554ed4b40b13e16f$export$71511d61b312f219)(function() {
                    var _Game_DIRECTIONS, UP, DOWN, LEFT, RIGHT, _obj, moveMap, _ref, canMove, move, _this_spawnTiles, newTile;
                    return (0, $fc5e3658b603cf39$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if ((0, $2f97c2a4ea6269f4$export$71511d61b312f219)(_this, $de28aad8650ac562$var$_status) !== Game.GAME_STATUS.playing) return [
                                    2
                                ];
                                _Game_DIRECTIONS = Game.DIRECTIONS, UP = _Game_DIRECTIONS.UP, DOWN = _Game_DIRECTIONS.DOWN, LEFT = _Game_DIRECTIONS.LEFT, RIGHT = _Game_DIRECTIONS.RIGHT;
                                moveMap = (_obj = {}, (0, $cd5a47cf8ef6d766$export$71511d61b312f219)(_obj, UP, [
                                    _this.canMoveUp,
                                    _this.moveUp
                                ]), (0, $cd5a47cf8ef6d766$export$71511d61b312f219)(_obj, DOWN, [
                                    _this.canMoveDown,
                                    _this.moveDown
                                ]), (0, $cd5a47cf8ef6d766$export$71511d61b312f219)(_obj, LEFT, [
                                    _this.canMoveLeft,
                                    _this.moveLeft
                                ]), (0, $cd5a47cf8ef6d766$export$71511d61b312f219)(_obj, RIGHT, [
                                    _this.canMoveRight,
                                    _this.moveRight
                                ]), _obj);
                                _ref = (0, $efec029548ccee7f$export$71511d61b312f219)(moveMap[direction] || [], 2), canMove = _ref[0], move = _ref[1];
                                if (!(canMove === null || canMove === void 0 ? void 0 : canMove.call(_this))) return [
                                    2,
                                    false
                                ];
                                return [
                                    4,
                                    move.call(_this)
                                ];
                            case 1:
                                _state.sent();
                                _this.mergeTiles();
                                _this_spawnTiles = (0, $efec029548ccee7f$export$71511d61b312f219)(_this.spawnTiles(1), 1), newTile = _this_spawnTiles[0];
                                if (!(!_this.canMoveUp() && !_this.canMoveDown() && !_this.canMoveLeft() && !_this.canMoveRight())) return [
                                    3,
                                    3
                                ];
                                (0, $20d5c04b0c6865c9$export$71511d61b312f219)(_this, $de28aad8650ac562$var$_status, Game.GAME_STATUS.lose);
                                if (!newTile) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    newTile.waitForTransition(true)
                                ];
                            case 2:
                                _state.sent();
                                _state.label = 3;
                            case 3:
                                return [
                                    2,
                                    true
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "canMoveUp",
            value: function canMoveUp() {
                return (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $de28aad8650ac562$var$_canMove, $de28aad8650ac562$var$canMove).call(this, (0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $de28aad8650ac562$var$_grid).cellsByColumn);
            }
        },
        {
            key: "canMoveDown",
            value: function canMoveDown() {
                return (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $de28aad8650ac562$var$_canMove, $de28aad8650ac562$var$canMove).call(this, (0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $de28aad8650ac562$var$_grid).cellsByColumn.map(function(column) {
                    return (0, $227c6742e0ff6f82$export$71511d61b312f219)(column).reverse();
                }));
            }
        },
        {
            key: "canMoveLeft",
            value: function canMoveLeft() {
                return (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $de28aad8650ac562$var$_canMove, $de28aad8650ac562$var$canMove).call(this, (0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $de28aad8650ac562$var$_grid).cellsByRow);
            }
        },
        {
            key: "canMoveRight",
            value: function canMoveRight() {
                return (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $de28aad8650ac562$var$_canMove, $de28aad8650ac562$var$canMove).call(this, (0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $de28aad8650ac562$var$_grid).cellsByRow.map(function(row) {
                    return (0, $227c6742e0ff6f82$export$71511d61b312f219)(row).reverse();
                }));
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                return (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $de28aad8650ac562$var$_slideTiles, $de28aad8650ac562$var$slideTiles).call(this, (0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $de28aad8650ac562$var$_grid).cellsByColumn);
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                return (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $de28aad8650ac562$var$_slideTiles, $de28aad8650ac562$var$slideTiles).call(this, (0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $de28aad8650ac562$var$_grid).cellsByColumn.map(function(column) {
                    return (0, $227c6742e0ff6f82$export$71511d61b312f219)(column).reverse();
                }));
            }
        },
        {
            key: "moveLeft",
            value: function moveLeft() {
                return (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $de28aad8650ac562$var$_slideTiles, $de28aad8650ac562$var$slideTiles).call(this, (0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $de28aad8650ac562$var$_grid).cellsByRow);
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                return (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $de28aad8650ac562$var$_slideTiles, $de28aad8650ac562$var$slideTiles).call(this, (0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $de28aad8650ac562$var$_grid).cellsByRow.map(function(row) {
                    return (0, $227c6742e0ff6f82$export$71511d61b312f219)(row).reverse();
                }));
            }
        },
        {
            key: "mergeTiles",
            value: function mergeTiles() {
                var _this = this;
                var scoreGained = 0;
                (0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $de28aad8650ac562$var$_grid).cells.forEach(function(cell) {
                    var mergedValue = cell.mergeTiles();
                    if (mergedValue) {
                        scoreGained += mergedValue;
                        if (mergedValue === 2048) (0, $20d5c04b0c6865c9$export$71511d61b312f219)(_this, $de28aad8650ac562$var$_status, Game.GAME_STATUS.win);
                    }
                });
                (0, $20d5c04b0c6865c9$export$71511d61b312f219)(this, $de28aad8650ac562$var$_score, (0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $de28aad8650ac562$var$_score) + scoreGained);
            }
        },
        {
            key: "spawnTiles",
            value: function spawnTiles() {
                var count = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
                var tiles = [];
                for(var i = 0; i < count; i++){
                    var spawnedTile = (0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $de28aad8650ac562$var$_grid).spawnTile();
                    tiles.push(spawnedTile);
                }
                return tiles;
            }
        }
    ]);
    return Game;
}();
(0, $cd5a47cf8ef6d766$export$71511d61b312f219)($de28aad8650ac562$export$985739bfa5723e08, "GAME_STATUS", {
    idle: "idle",
    playing: "playing",
    win: "win",
    lose: "lose"
});
(0, $cd5a47cf8ef6d766$export$71511d61b312f219)($de28aad8650ac562$export$985739bfa5723e08, "DIRECTIONS", {
    UP: "up",
    DOWN: "down",
    LEFT: "left",
    RIGHT: "right"
});
function $de28aad8650ac562$var$canMove(cells) {
    return cells.some(function(group) {
        return group.some(function(cell, index) {
            if (index === 0) return false;
            if (cell.tile == null) return false;
            var moveToCell = group[index - 1];
            return moveToCell.canAccept(cell.tile);
        });
    });
}
function $de28aad8650ac562$var$slideTiles(cells) {
    return Promise.all(cells.flatMap(function(group) {
        var promises = [];
        for(var i = 1; i < group.length; i++){
            var cell = group[i];
            if (cell.tile == null) continue;
            var lastValidCell = void 0;
            for(var j = i - 1; j >= 0; j--){
                var moveToCell = group[j];
                if (!moveToCell.canAccept(cell.tile)) break;
                lastValidCell = moveToCell;
            }
            if (lastValidCell != null) {
                promises.push(cell.tile.waitForTransition());
                if (lastValidCell.tile != null) lastValidCell.mergeTile = cell.tile;
                else lastValidCell.tile = cell.tile;
                cell.tile = null;
            }
        }
        return promises;
    }));
}


var $197cd56b15c33885$var$gameField = document.querySelector(".game__field");
var $197cd56b15c33885$var$button = document.querySelector(".button");
var $197cd56b15c33885$var$gameScore = document.querySelector(".game__score");
var $197cd56b15c33885$var$loseMessage = document.querySelector(".message--lose");
var $197cd56b15c33885$var$winMessage = document.querySelector(".message--win");
var $197cd56b15c33885$var$startMessage = document.querySelector(".message--start");
var $197cd56b15c33885$var$game = new (0, $de28aad8650ac562$export$985739bfa5723e08)($197cd56b15c33885$var$gameField);
var $197cd56b15c33885$var$DIRECTIONS = (0, $de28aad8650ac562$export$985739bfa5723e08).DIRECTIONS;
var $197cd56b15c33885$var$touchStartX = null;
var $197cd56b15c33885$var$touchStartY = null;
var $197cd56b15c33885$var$SWIPE_THRESHOLD = 30;
$197cd56b15c33885$var$button.addEventListener("click", $197cd56b15c33885$var$handleButtonClick);
function $197cd56b15c33885$var$handleButtonClick() {
    if ($197cd56b15c33885$var$game.status === (0, $de28aad8650ac562$export$985739bfa5723e08).GAME_STATUS.idle) $197cd56b15c33885$var$startGame();
    else $197cd56b15c33885$var$restartGame();
}
function $197cd56b15c33885$var$handleTouchStart(e) {
    e.preventDefault();
    var touch = e.changedTouches[0];
    $197cd56b15c33885$var$touchStartX = touch.clientX;
    $197cd56b15c33885$var$touchStartY = touch.clientY;
}
function $197cd56b15c33885$var$handleTouchEnd(e) {
    return $197cd56b15c33885$var$_handleTouchEnd.apply(this, arguments);
}
function $197cd56b15c33885$var$_handleTouchEnd() {
    $197cd56b15c33885$var$_handleTouchEnd = (0, $554ed4b40b13e16f$export$71511d61b312f219)(function(e) {
        var touch, dx, dy, direction;
        return (0, $fc5e3658b603cf39$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    e.preventDefault();
                    touch = e.changedTouches[0];
                    dx = touch.clientX - $197cd56b15c33885$var$touchStartX;
                    dy = touch.clientY - $197cd56b15c33885$var$touchStartY;
                    if (Math.abs(dx) < $197cd56b15c33885$var$SWIPE_THRESHOLD && Math.abs(dy) < $197cd56b15c33885$var$SWIPE_THRESHOLD) return [
                        2
                    ];
                    if (Math.abs(dx) > Math.abs(dy)) direction = dx > 0 ? $197cd56b15c33885$var$DIRECTIONS.RIGHT : $197cd56b15c33885$var$DIRECTIONS.LEFT;
                    else direction = dy > 0 ? $197cd56b15c33885$var$DIRECTIONS.DOWN : $197cd56b15c33885$var$DIRECTIONS.UP;
                    return [
                        4,
                        $197cd56b15c33885$var$processMove(direction)
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return $197cd56b15c33885$var$_handleTouchEnd.apply(this, arguments);
}
function $197cd56b15c33885$var$processMove(direction) {
    return $197cd56b15c33885$var$_processMove.apply(this, arguments);
}
function $197cd56b15c33885$var$_processMove() {
    $197cd56b15c33885$var$_processMove = (0, $554ed4b40b13e16f$export$71511d61b312f219)(function(direction) {
        var moved;
        return (0, $fc5e3658b603cf39$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $197cd56b15c33885$var$game.tryMove(direction)
                    ];
                case 1:
                    moved = _state.sent();
                    if (moved) {
                        $197cd56b15c33885$var$updateScore();
                        if ($197cd56b15c33885$var$game.isWin) {
                            $197cd56b15c33885$var$winMessage.classList.remove("hidden");
                            $197cd56b15c33885$var$removeTouchListeners();
                            return [
                                2
                            ];
                        }
                        if ($197cd56b15c33885$var$game.isGameOver) {
                            $197cd56b15c33885$var$loseMessage.classList.remove("hidden");
                            $197cd56b15c33885$var$removeTouchListeners();
                            return [
                                2
                            ];
                        }
                    }
                    $197cd56b15c33885$var$setupInput();
                    return [
                        2
                    ];
            }
        });
    });
    return $197cd56b15c33885$var$_processMove.apply(this, arguments);
}
function $197cd56b15c33885$var$handleKeyDown(e) {
    return $197cd56b15c33885$var$_handleKeyDown.apply(this, arguments);
}
function $197cd56b15c33885$var$_handleKeyDown() {
    $197cd56b15c33885$var$_handleKeyDown = (0, $554ed4b40b13e16f$export$71511d61b312f219)(function(e) {
        var direction;
        return (0, $fc5e3658b603cf39$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    direction = ({
                        ArrowUp: $197cd56b15c33885$var$DIRECTIONS.UP,
                        ArrowDown: $197cd56b15c33885$var$DIRECTIONS.DOWN,
                        ArrowLeft: $197cd56b15c33885$var$DIRECTIONS.LEFT,
                        ArrowRight: $197cd56b15c33885$var$DIRECTIONS.RIGHT
                    })[e.key];
                    if (!direction) {
                        $197cd56b15c33885$var$setupInput();
                        return [
                            2
                        ];
                    }
                    return [
                        4,
                        $197cd56b15c33885$var$processMove(direction)
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return $197cd56b15c33885$var$_handleKeyDown.apply(this, arguments);
}
function $197cd56b15c33885$var$setupInput() {
    window.addEventListener("keydown", $197cd56b15c33885$var$handleKeyDown, {
        once: true
    });
}
function $197cd56b15c33885$var$updateScore() {
    $197cd56b15c33885$var$gameScore.textContent = $197cd56b15c33885$var$game.score;
}
function $197cd56b15c33885$var$startGame() {
    $197cd56b15c33885$var$button.classList.remove("button--start");
    $197cd56b15c33885$var$button.classList.add("button--restart");
    $197cd56b15c33885$var$button.textContent = "Restart";
    $197cd56b15c33885$var$startMessage.classList.add("hidden");
    $197cd56b15c33885$var$game.start();
    $197cd56b15c33885$var$setupInput();
    $197cd56b15c33885$var$gameField.addEventListener("touchstart", $197cd56b15c33885$var$handleTouchStart);
    $197cd56b15c33885$var$gameField.addEventListener("touchend", $197cd56b15c33885$var$handleTouchEnd);
}
function $197cd56b15c33885$var$restartGame() {
    $197cd56b15c33885$var$winMessage.classList.add("hidden");
    $197cd56b15c33885$var$loseMessage.classList.add("hidden");
    $197cd56b15c33885$var$startMessage.classList.remove("hidden");
    $197cd56b15c33885$var$button.classList.remove("button--restart");
    $197cd56b15c33885$var$button.classList.add("button--start");
    $197cd56b15c33885$var$button.textContent = "Start";
    $197cd56b15c33885$var$game.restart();
    $197cd56b15c33885$var$updateScore();
    $197cd56b15c33885$var$removeTouchListeners();
}
function $197cd56b15c33885$var$removeTouchListeners() {
    $197cd56b15c33885$var$gameField.removeEventListener("touchstart", $197cd56b15c33885$var$handleTouchStart);
    $197cd56b15c33885$var$gameField.removeEventListener("touchend", $197cd56b15c33885$var$handleTouchEnd);
}

})();
//# sourceMappingURL=index.8b9dfdfa.js.map
